module.exports = __webpack_public_path__ + "img/讲座沙龙类.6fe710a1.png";